import GoogleDriveIcon from 'assets/icons/google-drive.svg';
import SuccessIcon from 'assets/icons/success-icon.svg';
import SyncIcon from 'assets/icons/sync-icon.svg';
import React from 'react';
import colors from 'theme/colors';
import { Group, Stack, Text } from 'ui';
import * as Layout from './Layout';

export const IntegrationSuccessful: React.FC = () => {
  return (
    <Layout.SuccessIntegrationsMenuContainer gap="20px" data-cy="integration-successful-container">
      <Group
        gap="20px"
        align="center"
        justify="center"
        fluid
        data-cy="integration-successful-icon-group"
      >
        <img width={88} height={75} alt="google-drive-icon" src={GoogleDriveIcon} />
        <img width={44} height={44} alt="synchronization-icon" src={SyncIcon} />
        <img width={100} height={100} alt="success-checkmark-icon" src={SuccessIcon} />
      </Group>
      <Stack gap="12px">
        <Text
          weight="600"
          align="center"
          size="lg"
          cypressAttribute="integration-successful-text-1"
        >
          Integrated successfully
        </Text>
        <Text
          weight="400"
          align="left"
          size="sm"
          style={{ lineHeight: 1.3, letterSpacing: 0.4 }}
          cypressAttribute="integration-successful-text-2"
        >
          Your files are now integrated with Google Workspace. For more information on usage, please
          see our{' '}
          <a
            href="https://www.authentise.com/help-pages/threads/integrations"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none', color: colors.brandSecondaryLight }}
            data-cy="integration-successful-text-link"
          >
            Help Section
          </a>
          .
        </Text>
      </Stack>
    </Layout.SuccessIntegrationsMenuContainer>
  );
};
